import { useRecoilState } from 'recoil'
import useItemsSetter from '../../../../../recoil/useItemsSetter'
import useTableWithRequest from '../../../../../shared/Table/useTableWithRequest'
import { useCallback } from 'react'
import { IProjectRole } from '../../projectRoles.types'
import projectRolesTableAtom from './projectRolesTable.atom'
import projectRolesApi from '../../projectRoles.api'
import projectRolesTableFields from './projectRolesTable.fields'
import Table from 'shared/Table'

interface IProps {
  onClick?: (user: IProjectRole) => void
}

const ProjectRolesTable = (props: IProps) => {
  const [projectRolesTableState] = useRecoilState(projectRolesTableAtom)

  const fetcher = useCallback((params: Record<string, any>) => {
    return projectRolesApi.getList({
      ...params,
    })
  }, [])

  const itemsSetter = useItemsSetter(projectRolesTableAtom)

  const tableCtrl = useTableWithRequest({
    dataFetcher: fetcher,
    fields: projectRolesTableFields,
    itemKey: 'id',
    items: projectRolesTableState.items,
    setItems: itemsSetter,
    tableKey: 'project-roles',
    serverSideOrder: true,
  })

  return (
    <div className='flex-lines' style={{ height: '100%' }}>
      <Table
        {...tableCtrl}
        items={tableCtrl.orderedItems}
        handleSelect={tableCtrl.selectedCtrl.setSelected}
        selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof IProjectRole>}
        handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
        itemKey='id'
        onCLick={props.onClick}
        selectEnabled={false}
      />
    </div>
  )
}

export default ProjectRolesTable
